module.exports = __webpack_public_path__ + "@/assets/img/street-view-solid.9cbbe3cd.svg";